import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgFilterApplied = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 20,
	height: 20,
	viewBox: "0 0 20 20",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		d: "M10.416 3H4.09387C3.67109 3 3.28632 3.27813 3.10537 3.71471H3.10539C2.92439 4.15128 2.97963 4.66786 3.24727 5.04162L8.25059 12.0284V14.5003C8.25059 14.816 8.37912 15.1129 8.60063 15.3004L10.3508 16.8004C10.6161 17.0286 10.9716 17.0629 11.2669 16.8942C11.565 16.7254 11.751 16.3785 11.751 16.0004V12.0284L13.3864 9.73391C11.4167 9.06272 10 7.19681 10 5C10 4.2889 10.1484 3.61246 10.416 3Z",
		fillRule: "evenodd",
		clipRule: "evenodd",
		fill: "#0D2976"
	}), /* @__PURE__ */ _jsx("circle", {
		cx: 15,
		cy: 5,
		r: 4,
		fill: "#D42A36"
	})]
});
export default SvgFilterApplied;
